<ng-container #prefix></ng-container>
<div class="label">
  <rt-icon [name]="iconName" [size]="iconSize" />
</div>
<ng-container #suffix></ng-container>
